export const STYLE_OPTION_FIELD_TYPE = {
  TEXT: 'text',
  COLOR: 'color'
}

export const STYLE_OPTION_FIELD_DISPLAY = {
  MAIN: 'main',
  EXTRA: 'extra',
  AFTER: 'after',
}